import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import SweetAlert2 from "react-sweetalert2";
import { CheckIsNull } from "../../../utils/CommonHelper";
import * as actions from "../redux/PromotionAction";
import { PromotionDetailModal } from "./promotionDetail/PromotionDetailModal";

export const PromotionListing = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const [swalProps, setSwalProps] = useState({});
  const [promotionId, setPromotionId] = useState();
  const promotionState = useSelector(
    ({ promotion }) => promotion,
    shallowEqual
  );

  useEffect(() => {
    const params = {
      action: "promotionlist",
    };

    dispatch(actions.getPromotionPageList(params));
  }, []);

  return (
    <div>
      <div style={styles.navBar} className="position-relative">
        <div className="text-font4" style={styles.title}>
          {intl.formatMessage({ id: "promotion" })}
        </div>
      </div>
      <SweetAlert2
        heightAuto={false}
        onResolve={() => {
          setSwalProps({});
        }}
        {...swalProps}
        customClass="custom-swal"
      />
      <PromotionDetailModal
        promotionId={promotionId}
        setPromotionId={setPromotionId}
        setSwalProps={setSwalProps}
      />
      <div
        style={{ paddingBottom: "6vh" }}
        className="d-flex flex-column gap-2 px-3"
      >
        {promotionState.promotionPageList?.promotionLists?.map(
          (promotion, index) => (
            <div
              key={index}
              className="card p-2"
              style={{
                backgroundColor: "#1c1e23",
              }}
              onClick={() => {
                setPromotionId(promotion.promotionid);
              }}
            >
              <div className="card-body p-0 d-flex flex-column align-items-stretch gap-1 position-relative">
                {promotion.claimactive === "true" && (
                  <img
                    src={`${process.env.PUBLIC_URL}/image/icon/giftcard.webp`}
                    className="position-absolute end-0"
                    style={{ width: "20px" }}
                  />
                )}
                {!CheckIsNull(promotion.promotionimage) && (
                  <img
                    alt={promotion.promotiontitle}
                    src={promotion.promotionimage}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                )}
                {CheckIsNull(promotion.promotionimage) && (
                  <div
                    className="fw-bold text-font3"
                    style={{ color: "#f5be09" }}
                  >
                    {promotion.promotiontitle}
                  </div>
                )}
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};
const styles = {
  navBar: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "60px",
    backgroundColor: "black",
  },
  backButton: {
    position: "absolute",
    left: "10px",
    fontSize: "20px",
  },
  title: {
    fontWeight: "bold",
    color: "white",
  },
};
